import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Box,
  LinearProgress,
  Button,
  FormControlLabel,
  FormControl,
  FormLabel,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import { ConfirmButton } from ".";
import { MultiSelectChips } from "../MultiSelectChips";
import { WatchActions, useDispatch } from "../../../../state";
import { useForceUpdate } from "../../../../lib";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import RemoveCircleOutlineOutlinedIcon from "@material-ui/icons/RemoveCircleOutlineOutlined";
import { RecentValuesInput } from "../RecentValuesInput";

const selectStyle: React.CSSProperties = {
  fontSize: "12px",
  height: "24px",
  padding: "2px 12px 2px 5px",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  backgroundColor: "transparent",
  width: "100%",
};

const inputStyle: React.CSSProperties = {
  fontSize: "12px",
  height: "24px",
  padding: "2px 5px",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  backgroundColor: "transparent",
  width: "100%",
  boxSizing: "border-box",
  outline: "none",
  fontFamily: "inherit",
};

const labelStyle: React.CSSProperties = {
  fontSize: 11,
  display: "block",
  marginBottom: 2,
};

interface Props {
  brand: any;
  stub: any;
  sites_router_metum: any;
  custom_aka: boolean;
  myTitle: any;
  id: any;
  myBrand: any;
  brandListTitle: any;
  setMyBrand: any;
  setMyBrandId: any;
  setEditBrand: any;
  myBrandId: any;
  complicationsList: any;
  certificationList: any;
  calibreList: any;
  defaultCert: any;
  defaultCalibre: any;
  brandTitle: any;
  rawAttribute: any;
  attribute: any;
  base_calibre: any;
  brand_id: number;
  calibre: any;
  can_delete: true;
  certification_id: any;
  components: any;
  description: any;
  description_gb: any;
  item_calibre_complications: any;
  movement: any;
  calibre_complication_details: any;
  calibre_id: number;
  movement_type_id: number | null;
  movementTypeList: any[];
  parent_calibre_id: number;
  reserve_days: number;
  reserve_hours: number;
  reserve_notes: any;
  vph: number;
  jewels: number;
  in_house: boolean;
}

export function CalibreDetails(props: Props) {
  let forceUpdate = useForceUpdate();
  const dispatch = useDispatch();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const compList: any[] = props.complicationsList || [];
  const compCheck: any[] = props.item_calibre_complications || [];
  const compNotesRef = useRef<any[]>(
    (props.item_calibre_complications || [])
      .filter((c: any) => c.item_calibre_complication_ref?.details)
      .flatMap((c: any) =>
        c.item_calibre_complication_ref.details
          .split("\n")
          .filter((line: string) => line.trim())
          .map((line: string) => ({
            calibre_id: Number(props.id),
            calibre_complication_id: c.complication_id,
            details: line,
          }))
      )
  );
  const compNotes = compNotesRef.current;

  const [certificationIds, setCertificationIds] = useState<number[]>(
    (props.defaultCert || []).map((c: any) => c.certification_id).filter(Boolean),
  );
  const [selectedBrandId, setSelectedBrandId] = useState<number | null>(props.brand_id ?? null);

  useEffect(() => {
    setCertificationIds((props.defaultCert || []).map((c: any) => c.certification_id).filter(Boolean));
  }, [props.defaultCert]);

  const [calibreValue, setCalibreValue] = useState<any>(props.defaultCalibre?.[0]?.calibre_id ?? "");
  const [movementTypeId, setMovementTypeId] = useState<number | null>(props.movement_type_id ?? null);

  useEffect(() => {
    setCalibreValue(props.defaultCalibre?.[0]?.calibre_id ?? "");
    setMovementTypeId(props.movement_type_id ?? null);
    setSelectedBrandId(props.brand_id ?? null);
    setCalibreName(props.calibre ?? "");
    setJewels(props.jewels ?? "");
    setComponents(props.components ?? "");
    setReserveHours(props.reserve_hours ?? "");
    setReserveDays(props.reserve_days ?? "");
    setReserveNotes(props.reserve_notes ?? "");
    setDescription(props.description ?? "");
    set_in_house(!!props.in_house);
    setVph(props.vph ?? "");
    setHz(props.vph ? props.vph / 7200 : "");
    setEol(!!(props as any).eol);
    setEolNotes((props as any).eol_notes ?? "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  const [in_house_Movement, set_in_house] = useState<any>(props.in_house);
  const [calibreName, setCalibreName] = useState<any>(props.calibre ?? "");
  const [vph, setVph] = useState<any>(props.vph ?? "");
  const [hz, setHz] = useState<any>(props.vph ? props.vph / 7200 : "");
  const [errorDialog, setErrorDialog] = useState(false);
  const [jewels, setJewels] = useState<any>(props.jewels ?? "");
  const [components, setComponents] = useState<any>(props.components ?? "");
  const [reserveHours, setReserveHours] = useState<any>(props.reserve_hours ?? "");
  const [reserveDays, setReserveDays] = useState<any>(props.reserve_days ?? "");
  const [reserveNotes, setReserveNotes] = useState<any>(props.reserve_notes ?? "");
  const [description, setDescription] = useState<any>(props.description ?? "");
  // EOL — quartz calibres only (UI gated on movement type)
  const [eol, setEol] = useState<boolean>(!!(props as any).eol);
  const [eolNotes, setEolNotes] = useState<any>((props as any).eol_notes ?? "");

  function handleChangeHz(e: any) {
    setHz(e.target.value);
    setVph(e.target.value ? Math.round(e.target.value * 7200) : "");
    setIsDisabled(false);
    if (e.target.value % 0.5 !== 0) {
      setErrorDialog(true);
    } else setErrorDialog(false);
  }

  function handleChangeVph(e: any) {
    setVph(e.target.value);
    setHz(e.target.value ? e.target.value / 7200 : "");
    setIsDisabled(false);
    if (e.target.value % 7200 !== 0) {
      setErrorDialog(true);
    } else setErrorDialog(false);
  }

  function handleChangeHours(e: any) {
    const val = e.target.value;
    setReserveHours(val);
    setReserveDays(val !== "" && Number(val) > 0 ? parseFloat((Number(val) / 24).toFixed(2)) : "");
    markDirty();
  }

  function handleChangeDays(e: any) {
    const val = e.target.value;
    setReserveDays(val);
    setReserveHours(val !== "" && Number(val) > 0 ? Math.round(Number(val) * 24) : "");
    markDirty();
  }

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await dispatch(
      WatchActions.editMovement(`/calibre-details/${props.id}`, {
        in_house: in_house_Movement ? in_house_Movement : false,
        movement_type_id: movementTypeId ?? null,
        brand_id: selectedBrandId ?? props.brand_id,
        calibre: calibreName,
        certification_ids: certificationIds,
        parent_calibre_id: calibreValue || null,
        description: description,
        eol: eol ? 1 : 0,
        eol_notes: eolNotes || null,
        reserve_days: Number(reserveDays) || 0,
        reserve_hours: Number(reserveHours) || 0,
        reserve_notes: reserveNotes,
        hz: hz !== "" ? Number(hz) : null,
        vph: Number(vph) || 0,
        components: components !== "" ? Number(components) : null,
        complications: compCheck.map((checkedId: any) => checkedId.complication_id),
        complication_details: Object.values(
          compNotes.reduce((acc: any, note: any) => {
            const id = note.calibre_complication_id;
            if (!acc[id]) acc[id] = { calibre_id: note.calibre_id, calibre_complication_id: id, details: [] };
            if (note.details?.trim()) acc[id].details.push(note.details.trim());
            return acc;
          }, {})
        ).map((n: any) => ({ ...n, details: n.details.join("\n") || null })),
        jewels: jewels ? Number(jewels) : 0,
      }),
    );
    const fresh = await WatchActions.getMovementDetails(props.id);
    if (fresh?.item_certifications) {
      setCertificationIds(fresh.item_certifications.map((c: any) => c.certification_id).filter(Boolean));
    }
    setIsSubmitting(false);
    setIsDisabled(true);
  };

  const markDirty = () => setIsDisabled(false);

  const brandListTitle = props.brandListTitle || [];
  const calibreList = props.calibreList || [];
  const movementTypeList = props.movementTypeList || [];
  const certificationList = (props.certificationList || []).filter(
    (cert: any) => cert.brand_id === selectedBrandId || cert.brand_id === null,
  );

  return (
    <div style={{ width: "100%" }}>
      <Box
        boxShadow={2}
        display="flex"
        flexWrap="wrap"
        flexDirection="column"
        alignItems="left"
        my={4}
        p={2}
        pt={2}
      >
        {/* Row 1: Calibre name + Brand */}
        <Box m={1} display="flex" style={{ gap: 12 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Calibre</label>
            <RecentValuesInput
              rememberKey="calibre_name"
              style={inputStyle}
              value={calibreName}
              onChange={(e) => { setCalibreName(e.target.value); markDirty(); }}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Brand Affiliation</label>
            <select
              style={selectStyle}
              value={selectedBrandId ?? ""}
              onChange={(e) => {
                const val = e.target.value ? Number(e.target.value) : null;
                setSelectedBrandId(val);
                if (props.setMyBrand) props.setMyBrand(brandListTitle.find((b: any) => b.id === val)?.title ?? null);
                if (props.setMyBrandId) props.setMyBrandId(val);
                if (props.setEditBrand) props.setEditBrand(val);
                markDirty();
              }}
            >
              <option value=""></option>
              {brandListTitle.map((b: any) => (
                <option key={b.id} value={b.id}>{b.title}</option>
              ))}
            </select>
          </div>
        </Box>

        {/* Row 2: In House + Movement Type + Certification */}
        <Box m={1} display="flex" alignItems="flex-end" style={{ gap: 12 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <label style={labelStyle}>In House</label>
            <Checkbox
              color="primary"
              checked={!!in_house_Movement}
              onClick={() => { set_in_house(!in_house_Movement); markDirty(); }}
              style={{ padding: 0 }}
            />
          </div>
          <div style={{ width: 200 }}>
            <label style={labelStyle}>Movement Type</label>
            <select
              style={selectStyle}
              value={movementTypeId ?? ""}
              onChange={(e) => {
                setMovementTypeId(e.target.value ? Number(e.target.value) : null);
                markDirty();
              }}
            >
              <option value=""></option>
              {movementTypeList.map((m: any) => (
                <option key={m.movement_id} value={m.movement_id}>{m.movement}</option>
              ))}
            </select>
          </div>
          {!!movementTypeId && movementTypeList.some((m: any) => m.movement_id === movementTypeId && (m.movement || "").toLowerCase() === "quartz") && (
            <>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <label style={labelStyle}>EOL</label>
                <Checkbox
                  color="primary"
                  checked={!!eol}
                  onClick={() => { setEol(!eol); markDirty(); }}
                  style={{ padding: 0 }}
                />
              </div>
              <div style={{ width: 140 }}>
                <label style={labelStyle}>EOL Notes</label>
                <RecentValuesInput
                  rememberKey="calibre_eol_notes"
                  style={selectStyle}
                  type="text"
                  value={eolNotes}
                  onChange={(e) => { setEolNotes(e.target.value); markDirty(); }}
                />
              </div>
            </>
          )}
          {props.certificationList && (
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Brand Certification</label>
              <MultiSelectChips
                value={certificationIds}
                onChange={(ids) => { setCertificationIds(ids); markDirty(); }}
                options={certificationList}
                getOptionValue={(c: any) => c.certification_id}
                getOptionLabel={(c: any) => c.certification}
                style={{ width: "100%", border: "1px solid rgba(0,0,0,0.23)" }}
              />
            </div>
          )}
        </Box>

        {/* Row 3: Base Calibre + HZ + VPH + Jewels + Components + Hours + Days */}
        <Box m={1} display="flex" alignItems="flex-end" style={{ gap: 12 }}>
          {props.calibreList && (
            <div style={{ width: 200 }}>
              <label style={labelStyle}>Base Calibre</label>
              <select
                style={selectStyle}
                value={calibreValue ?? ""}
                onChange={(e) => {
                  setCalibreValue(e.target.value ? Number(e.target.value) : "");
                  markDirty();
                }}
              >
                <option value=""></option>
                {calibreList.map((c: any) => (
                  <option key={c.calibre_id} value={c.calibre_id}>{c.calibre}</option>
                ))}
              </select>
            </div>
          )}
          <div style={{ width: 60 }}>
            <label style={{ ...labelStyle, color: errorDialog ? "red" : labelStyle.color }}>
              {errorDialog ? "Invalid HZ:" : "HZ"}
            </label>
            <RecentValuesInput
              rememberKey="calibre_hz"
              style={{ ...inputStyle, borderColor: errorDialog ? "red" : undefined }}
              type="number"
              value={hz}
              onChange={handleChangeHz}
            />
          </div>
          <div style={{ width: 70 }}>
            <label style={labelStyle}>VPH</label>
            <RecentValuesInput
              rememberKey="calibre_vph"
              style={inputStyle}
              type="number"
              value={vph}
              onChange={handleChangeVph}
            />
          </div>
          <div style={{ width: 60 }}>
            <label style={labelStyle}>Jewels</label>
            <RecentValuesInput
              rememberKey="calibre_jewels"
              style={inputStyle}
              type="number"
              value={jewels}
              onChange={(e) => { setJewels(e.target.value); markDirty(); }}
            />
          </div>
          <div style={{ width: 80 }}>
            <label style={labelStyle}>Components</label>
            <RecentValuesInput
              rememberKey="calibre_components"
              style={inputStyle}
              type="number"
              value={components}
              onChange={(e) => { setComponents(e.target.value); markDirty(); }}
            />
          </div>
          <div style={{ width: 70 }}>
            <label style={labelStyle}>Hours</label>
            <RecentValuesInput
              rememberKey="calibre_reserve_hours"
              style={inputStyle}
              type="number"
              value={reserveHours}
              onChange={handleChangeHours}
            />
          </div>
          <div style={{ width: 70 }}>
            <label style={labelStyle}>Days</label>
            <RecentValuesInput
              rememberKey="calibre_reserve_days"
              style={inputStyle}
              type="number"
              value={reserveDays}
              onChange={handleChangeDays}
            />
          </div>
        </Box>

        {/* Row 4: Power Reserve Notes */}
        <Box m={1}>
          <label style={labelStyle}>Power Reserve Notes</label>
          <RecentValuesInput
            rememberKey="calibre_reserve_notes"
            style={{ ...inputStyle, width: "100%" }}
            value={reserveNotes ?? ""}
            onChange={(e) => { setReserveNotes(e.target.value); markDirty(); }}
          />
        </Box>

        {/* Row 5: Movement Notes */}
        <Box m={1}>
          <label style={labelStyle}>Movement Notes</label>
          <ReactQuill
            theme="snow"
            value={description ?? ""}
            onChange={(content) => { setDescription(content); markDirty(); }}
          />
        </Box>

        {/* Complications */}
        {props.complicationsList && (
          <FormControl component="fieldset" style={{ width: "100%", marginLeft: 8 }}>
            <FormLabel component="legend" style={{ fontSize: 11 }}>Select Complications</FormLabel>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "2px 0", marginTop: 4 }}>
              {compList.map((list: any, index: any) => {
                const listId = list.complication_id ?? list.calibre_complication_id;
                const listName = list.complication ?? list.calibre_complication;
                for (let i = 0; i < compCheck.length; i++) {
                  if (compCheck[i].complication_id === listId) {
                    compList.splice(index, 1);
                    forceUpdate();
                  }
                }
                return (
                  <FormControlLabel
                    key={listId}
                    value="start"
                    control={
                      <Checkbox
                        color="primary"
                        size="medium"
                        checked={false}
                        onClick={() => {
                          compList.splice(index, 1);
                          compCheck.push({ complication_id: listId, complication: listName });
                          markDirty();
                          forceUpdate();
                        }}
                      />
                    }
                    label={listName}
                    labelPlacement="end"
                  />
                );
              })}
            </div>
          </FormControl>
        )}

        <Box>
          {compCheck.map((value: any, index: any) => {
            return (
              <Box key={value.complication_id ?? index}>
                <Box display="flex">
                  <Box>
                    <FormControlLabel
                      value="start"
                      control={
                        <Checkbox
                          color="primary"
                          checked={true}
                          onClick={() => {
                            compList.push(value);
                            compCheck.splice(index, 1);
                            markDirty();
                            forceUpdate();
                          }}
                        />
                      }
                      label={value.complication}
                      labelPlacement="end"
                    />
                  </Box>
                  <Tooltip title="Add Details Field">
                    <Button
                      onClick={() => {
                        compNotes.push({
                          calibre_id: Number(props.id),
                          calibre_complication_id: value.complication_id,
                          details: "",
                        });
                        markDirty();
                        forceUpdate();
                      }}
                    >
                      <AddCircleOutlineIcon />
                    </Button>
                  </Tooltip>
                </Box>

                {compNotes.map((note: any, noteIndex: number) => {
                  if (note.calibre_complication_id === value.complication_id) {
                    return (
                      <Box key={noteIndex} ml={5} pt={1} display="flex" alignItems="center">
                        <RecentValuesInput
                          rememberKey="calibre_complication_details"
                          wrapperStyle={{ flex: 1 }}
                          style={inputStyle}
                          value={note.details}
                          onChange={(event: any) => {
                            compNotes[noteIndex].details = event.target.value;
                            forceUpdate();
                          }}
                        />
                        <Tooltip title="Delete">
                          <Button
                            onClick={() => {
                              compNotes.splice(noteIndex, 1);
                              markDirty();
                              forceUpdate();
                            }}
                            style={{ minWidth: 0, padding: 4 }}
                          >
                            <RemoveCircleOutlineOutlinedIcon color="secondary" style={{ fontSize: 18 }} />
                          </Button>
                        </Tooltip>
                      </Box>
                    );
                  }
                  return null;
                })}
              </Box>
            );
          })}
        </Box>

        <Box m={1} display="flex" justifyContent="space-between">
          {isSubmitting && <LinearProgress />}
          {!props.attribute?.endsWith("_group") && (
            <Button
              variant="contained"
              color="primary"
              disabled={isDisabled}
              onClick={handleSubmit}
            >
              Save Calibre
            </Button>
          )}

          {props.can_delete && (
            <ConfirmButton
              attribute={props.attribute}
              myValue={calibreName}
              myBrand={props.myBrand}
              myBrandId={props.brand_id}
              id={props.id}
              rawAttribute={props.rawAttribute}
              Add_Edit_Delete={"delete"}
              color={"secondary"}
              disabled={false}
              path={"movement-attribute"}
            />
          )}
        </Box>
      </Box>
    </div>
  );
}